import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";

const withStatus = WrappedComponent => ({ dispatch, status, ...rest }) => (
    <WrappedComponent disabled={status !== "editing"} {...rest} />
);

const mapStateToProps = (state, { storeName }) => ({
    status: state[storeName].status,
});

export default compose(
    connect(mapStateToProps),
    withStatus
);
